import { defineFcm } from '../shared/factory';

export const FCM_SIGN_FORM_NPO_CONTACT_CONSENT = defineFcm('sign_form_npo_contact_consent')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-dolphin',
		scope: 'corgi-front-end',
		context: 'Sign a Petition form',
		description: 'Controls visibility of the NPO contact consent checkbox on the Sign a Petition form',
	});
